import React from "react";
import { useTranslation } from "react-i18next";
import "./WhyUs.css";
import { scrollToElementById } from "../../../../utils/scrollToId";

import icon1 from "../../../../assets/images/academy/ic1.svg";
import icon2 from "../../../../assets/images/academy/ic2.svg";
import icon3 from "../../../../assets/images/academy/ic3.svg";
import icon4 from "../../../../assets/images/academy/ic4.svg";

const FEATURE_KEYS = [
  { id: 1, key: "f1", icon: icon1 },
  { id: 2, key: "f2", icon: icon2 },
  { id: 3, key: "f3", icon: icon3 },
  { id: 4, key: "f4", icon: icon4 },
];

const WhyUs = () => {
  const { t } = useTranslation();

  const handleDiscoverCourses = () => {
    scrollToElementById("academy-courses");
  };

  return (
    <section className="whyus">
      <div className="whyus-container">
        
        {/* LEFT */}
        <div className="whyus-left">
          <span className="whyus-tag">{t("sections.academy.whyUs.tag")}</span>

          <h2 className="whyus-title">
            {t("sections.academy.whyUs.title")} <br />
            <span>{t("sections.academy.whyUs.titleAccent")}</span>
          </h2>

          <p className="whyus-text">{t("sections.academy.whyUs.text")}</p>

          <button type="button" className="buttongyp whyus-btn" onClick={handleDiscoverCourses}>
            {t("sections.academy.whyUs.cta")}
          </button>
        </div>

        {/* RIGHT */}
        <div className="whyus-right">
          {FEATURE_KEYS.map((item) => (
            <div key={item.id} className="whyus-card">
              <img
                src={item.icon}
                alt=""
                className="whyus-icon"
              />

              <p className="whyus-cardText">{t(`sections.academy.whyUs.features.${item.key}`)}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhyUs;
